import { useTranslation } from 'next-i18next';
import Train from '../../common/Icons/Train';
import Phone from '../../common/Icons/Phone';
import Map from '../../common/Icons/Map';
import SkipTranslationWrapper from '../../common/SkipTranslationWrapper';

type Props = {
  type: 'access' | 'tel' | 'sightseeing';
  text: string;
};

const ListItem = ({ type, text }: Props) => {
  const { t } = useTranslation('hotel');
  const getContents = () => {
    switch (type) {
      case 'access':
        return { icon: <Train size={32} />, title: t('access.access') };
      case 'tel':
        return { icon: <Phone size={32} />, title: t('access.phone_number') };
      default:
        return { icon: <Map size={32} />, title: t('access.sightseeing') };
    }
  };
  const contents = getContents();

  return (
    <div className="flex">
      <div className="mr-4 max-h-14 rounded-xl bg-gray-50 p-3 sm:mr-6">{contents.icon}</div>
      <div className="flex flex-col">
        <p className="pb-1 text-regular font-bold">{contents.title}</p>
        {type === 'tel' ? (
          <SkipTranslationWrapper tag="a" className="text-small text-gray-600" href={`tel:${text}`}>
            {text}
          </SkipTranslationWrapper>
        ) : (
          <p className="whitespace-pre-wrap text-small text-gray-600">{text}</p>
        )}
      </div>
    </div>
  );
};

export default ListItem;
